/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * LawyerofficesApi - axios parameter creator
 * @export
 */
export const LawyerofficesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all lawyer offices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesGet: async (trashed?: number, offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lawyeroffices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lawyerofficesIdGet', 'id', id)
            const localVarPath = `/lawyeroffices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesIdPut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lawyerofficesIdPut', 'id', id)
            const localVarPath = `/lawyeroffices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new lawyer office
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesPost: async (person?: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lawyeroffices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LawyerofficesApi - functional programming interface
 * @export
 */
export const LawyerofficesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LawyerofficesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all lawyer offices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lawyerofficesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lawyerofficesGet(trashed, offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lawyerofficesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lawyerofficesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lawyerofficesIdPut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lawyerofficesIdPut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new lawyer office
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lawyerofficesPost(person?: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lawyerofficesPost(person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LawyerofficesApi - factory interface
 * @export
 */
export const LawyerofficesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LawyerofficesApiFp(configuration)
    return {
        /**
         * Get all lawyer offices
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesGet(trashed?: number, offset?: number, size?: number, options?: any): AxiosPromise<Array<Person>> {
            return localVarFp.lawyerofficesGet(trashed, offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesIdGet(id: number, options?: any): AxiosPromise<Person> {
            return localVarFp.lawyerofficesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesIdPut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.lawyerofficesIdPut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new lawyer office
         * @param {Person} [person] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lawyerofficesPost(person?: Person, options?: any): AxiosPromise<Person> {
            return localVarFp.lawyerofficesPost(person, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LawyerofficesApi - object-oriented interface
 * @export
 * @class LawyerofficesApi
 * @extends {BaseAPI}
 */
export class LawyerofficesApi extends BaseAPI {
    /**
     * Get all lawyer offices
     * @param {number} [trashed] Get trashed items.
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawyerofficesApi
     */
    public lawyerofficesGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig) {
        return LawyerofficesApiFp(this.configuration).lawyerofficesGet(trashed, offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific lawyer office
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawyerofficesApi
     */
    public lawyerofficesIdGet(id: number, options?: AxiosRequestConfig) {
        return LawyerofficesApiFp(this.configuration).lawyerofficesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific lawyer office
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawyerofficesApi
     */
    public lawyerofficesIdPut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return LawyerofficesApiFp(this.configuration).lawyerofficesIdPut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new lawyer office
     * @param {Person} [person] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LawyerofficesApi
     */
    public lawyerofficesPost(person?: Person, options?: AxiosRequestConfig) {
        return LawyerofficesApiFp(this.configuration).lawyerofficesPost(person, options).then((request) => request(this.axios, this.basePath));
    }
}
